import { createTheme, MantineColorsTuple } from '@mantine/core';

// TimberTrack Color Palette
const timberTrackBlue: MantineColorsTuple = [
  '#e3f2fd',
  '#bbdefb',
  '#90caf9',
  '#64b5f6',
  '#42a5f5',
  '#03a9f4', // Primary
  '#039be5',
  '#0288d1',
  '#0277bd',
  '#01579b'
];

const timberTrackOrange: MantineColorsTuple = [
  '#fff3e0',
  '#ffe0b2',
  '#ffcc80',
  '#ffb74d',
  '#ffa726',
  '#f79007', // Primary
  '#fb8c00',
  '#f57c00',
  '#ef6c00',
  '#e65100'
];

const timberTrackGreen: MantineColorsTuple = [
  '#e8f5e8',
  '#c8e6c9',
  '#a5d6a7',
  '#81c784',
  '#66bb6a',
  '#00bf87', // Primary
  '#43a047',
  '#388e3c',
  '#2e7d32',
  '#1b5e20'
];

const timberTrackDark: MantineColorsTuple = [
  '#f5f5f5',
  '#eeeeee',
  '#e0e0e0',
  '#bdbdbd',
  '#9e9e9e',
  '#757575',
  '#616161',
  '#424242',
  '#212121',
  '#17252a' // Primary Dark
];

export const timberTrackTheme = createTheme({
  primaryColor: 'timbertrack-blue',
  colors: {
    'timbertrack-blue': timberTrackBlue,
    'timbertrack-orange': timberTrackOrange,
    'timbertrack-green': timberTrackGreen,
    'timbertrack-dark': timberTrackDark,
  },
  
  fontFamily: 'Open Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
  fontFamilyMonospace: 'Monaco, Courier, monospace',
  
  headings: {
    fontFamily: 'Open Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    fontWeight: '300',
    sizes: {
      h1: { fontSize: '3.375rem', lineHeight: '1.26' },
      h2: { fontSize: '2.625rem', lineHeight: '1.143' },
      h3: { fontSize: '2.25rem', lineHeight: '1.25' },
      h4: { fontSize: '1.25rem', lineHeight: '1.6', fontWeight: '600' },
      h5: { fontSize: '1.125rem', lineHeight: '1.55', fontWeight: '600' },
      h6: { fontSize: '1rem', lineHeight: '1.6', fontWeight: '600' },
    },
  },
  
  defaultRadius: 'md',
  
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          fontSize: '14px',
          transition: 'all 0.3s ease',
        },
      },
    },
    
    Card: {
      defaultProps: {
        radius: 'md',
        shadow: 'md',
      },
      styles: {
        root: {
          border: '1px solid #e0e0e0',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0px 8px 25px rgba(0, 0, 0, 0.15)',
          },
        },
      },
    },
    
    Paper: {
      defaultProps: {
        radius: 'md',
        shadow: 'sm',
      },
      styles: {
        root: {
          border: '1px solid #e0e0e0',
        },
      },
    },
    
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        input: {
          border: '1px solid #e0e0e0',
          '&:focus': {
            borderColor: '#03a9f4',
            boxShadow: '0 0 0 2px rgba(3, 169, 244, 0.2)',
          },
        },
      },
    },
    
    Select: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        input: {
          border: '1px solid #e0e0e0',
          '&:focus': {
            borderColor: '#03a9f4',
            boxShadow: '0 0 0 2px rgba(3, 169, 244, 0.2)',
          },
        },
      },
    },
    
    Badge: {
      defaultProps: {
        radius: 'sm',
      },
    },
  },
  
  other: {
    // TimberTrack specific colors
    timberTrackColors: {
      primary: '#03a9f4',
      secondary: '#f79007',
      success: '#00bf87',
      accent: '#6632ff',
      background: '#F5FAFD',
      surface: '#FFFFFF',
      dark: '#17252a',
      textPrimary: '#17252a',
      textSecondary: '#46707f',
    },
  },
});
